export default "__VITE_ASSET__4b6546a0__"